import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import api from "@/lib/apiClient";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ListChecks, Target, Play, Lightbulb } from "lucide-react";

const DIFF_COLOR = { Mudah: "bg-emerald-100 text-emerald-700", Sedang: "bg-amber-100 text-amber-700", Sulit: "bg-red-100 text-red-700" };

export default function Scenarios() {
  const navigate = useNavigate();
  const { data: scenarios = [], isLoading } = useQuery({ queryKey: ["scenarios"], queryFn: () => api.get("/scenarios").then((r) => r.data) });

  const launch = (s) => {
    navigate("/lab", { state: { scenario: s, preset_config: s.preset_config } });
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading font-extrabold text-3xl flex items-center gap-2">
          <ListChecks className="h-7 w-7 text-primary" /> Skenario Praktikum
        </h1>
        <p className="text-muted-foreground mt-1">Latihan terarah dengan tujuan, parameter awal, dan target hasil.</p>
      </div>

      {isLoading && <p className="text-muted-foreground">Memuat…</p>}

      <div className="grid md:grid-cols-2 gap-5">
        {scenarios.map((s) => (
          <Card key={s.id} className="rounded-md p-5 flex flex-col" data-testid={`scenario-${s.id}`}>
            <div className="flex items-start justify-between gap-3 mb-2">
              <h3 className="font-heading font-bold text-lg">{s.title}</h3>
              <Badge className={`${DIFF_COLOR[s.difficulty] || ""} border-0`}>{s.difficulty}</Badge>
            </div>
            <div className="space-y-2 text-sm flex-1">
              <p className="flex gap-2"><Target className="h-4 w-4 text-primary mt-0.5 flex-shrink-0" /><span><span className="font-semibold">Tujuan: </span>{s.objective}</span></p>
              <p className="flex gap-2"><Lightbulb className="h-4 w-4 text-amber-500 mt-0.5 flex-shrink-0" /><span className="text-muted-foreground">{s.instructions}</span></p>
              {s.target?.min_resolution && (
                <div className="font-data text-xs text-muted-foreground">Target: Rs ≥ {s.target.min_resolution}{s.target.max_runtime_min ? ` · runtime ≤ ${s.target.max_runtime_min} mnt` : ""}</div>
              )}
            </div>
            <Button className="mt-4 gap-2" onClick={() => launch(s)} data-testid={`launch-${s.id}`}>
              <Play className="h-4 w-4" /> Mulai di Lab
            </Button>
          </Card>
        ))}
      </div>

      {scenarios.length === 0 && !isLoading && <p className="text-muted-foreground">Belum ada skenario.</p>}
    </div>
  );
}
